"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldListWrapper = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const table_field_context_1 = require("./table-field-context");
exports.useStyles = makeStyles_1.default((theme) => ({
    noMatch: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        margin: '15px 0',
    },
}));
function TableFieldListWrapper({ children, }) {
    const classes = exports.useStyles();
    const { value } = react_1.useContext(table_field_context_1.TableFieldContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        value.length === 0 && (react_1.default.createElement("div", { className: classes.noMatch },
            react_1.default.createElement(Typography_1.default, null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_EMPTY_SOURCE", defaultMessage: "Nejsou dostupn\u00E9 \u017E\u00E1dn\u00E9 z\u00E1znamy." })))),
        children));
}
exports.TableFieldListWrapper = TableFieldListWrapper;
//# sourceMappingURL=table-field-list-wrapper.js.map